import { getOrdinalStringForNumber } from '../../functions/date/utils/get-ordinal-string-for-number';
/**
 * The default date configuration.
 */
export const defaultDateConfig = {
    formats: {
        iso: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
        dateLong: 'D MMMM YYYY',
        dateShort: 'DD/MM/YYYY',
        dateDefault: 'DD/MM/YYYY',
        timeShort: 'HH:mm',
        timeLong: 'HH:mm:ss',
        timeDefault: 'HH:mm:ss'
    },
    ianaTimeZoneName: undefined,
    ordinalStringFormatter: getOrdinalStringForNumber
};
//# sourceMappingURL=date.js.map